// Fase 23C: tipos del panel de supervision (espejo del contrato backend, SOLO LECTURA + acuse). El
// backend es autoritativo; nunca se envia businessId (sesion). Fechas 'YYYY-MM-DD' interpretadas en la
// zona horaria de CADA tienda.
import type { QuestionType } from './forms';

export const SUPERVISION_MAX_RANGE_DAYS = 366;
export type SubmissionContext = 'MANUAL' | 'SHIFT_CLOSE';
export type ReviewStatus = 'ALL' | 'PENDING' | 'REVIEWED';
export type TrendBucket = 'DAY' | 'WEEK' | 'MONTH';

// Filtros base compartidos por todas las consultas.
export interface SupervisionFilters {
  from: string;
  to: string;
  storeId?: string;
  templateId?: string;
  context?: SubmissionContext;
  includeVoided?: boolean;
}

export interface SupervisionSummary {
  submitted: number;
  manual: number;
  shiftClose: number;
  storesWithActivity: number;
  templatesWithActivity: number;
  drafts: number;
  attentionHits: number;
  submissionsWithAttention: number;
  pendingReview: number;
  reviewed: number;
}

export interface SupervisionStoreRow {
  storeId: string;
  storeName: string;
  submitted: number;
  submissionsWithAttention: number;
  attentionHits: number;
  pendingReview: number;
}

export interface SupervisionTemplateRow {
  templateId: string;
  name: string | null;
  submitted: number;
  stores: number;
  versions: number;
  lastSubmittedAt: string | null;
  submissionsWithAttention: number;
  attentionHits: number;
}

export interface AttentionItem {
  submissionId: string;
  questionId: string;
  formName: string | null;
  storeId: string;
  storeName: string;
  submittedAt: string;
  context: SubmissionContext;
  shiftCloseId: string | null;
  shiftCloseVoided: boolean;
  respondentName: string;
  questionText: string;
  questionType: QuestionType;
  answer: string;
  reviewed: boolean;
  reviewedAt: string | null;
  reviewedByName: string | null;
}

export interface TextItem {
  submissionId: string;
  questionId: string;
  questionText: string;
  text: string;
  submittedAt: string;
  storeId: string;
  storeName: string;
  formName: string | null;
  respondentName: string;
  attention: boolean;
}

export interface Pagination {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export interface TrendPoint {
  bucket: string;
  submissions: number;
  submissionsWithAttention: number;
  attentionHits: number;
}

// Analitica por pregunta logica (una o mas series si cambio de tipo entre versiones).
export interface QuestionYesNoStats { total: number; yes: number; no: number; attentionHits: number }
export interface QuestionNumberStats { count: number; sum: string; average: string | null; min: string | null; max: string | null; attentionHits: number }
export interface QuestionOptionRow { optionLogicalKey: string; label: string; selections: number; submissions: number }
export interface QuestionDistribution { answeredSubmissions: number; options: QuestionOptionRow[] }
export interface QuestionSeries {
  type: QuestionType;
  text: string;
  versions: number;
  yesNo?: QuestionYesNoStats;
  number?: QuestionNumberStats;
  distribution?: QuestionDistribution;
}
export interface QuestionAnalytics {
  logicalKey: string;
  series: QuestionSeries[];
  note: string | null;
}

export interface TemplateQuestionOption {
  logicalKey: string;
  text: string;
  type: QuestionType;
  answers: number;
}

export interface ReviewResult {
  reviewed: true;
  reviewedAt: string;
  reviewedByName: string;
}
